var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnderline = function SvgUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 199 12",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F2DD3",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M2 10.25C13.717 5.8 24.213 2.822 44.25 2.569c20.038-.253 19.166 4.73 39.94 3.746 20.772-.984 19.467-3.48 35.314-3.866 19.768-.482 24.532 4.43 44.19 4.058 19.659-.373 33.398-4.745 33.398-4.745"
  })));
};
export default SvgUnderline;